import { registriereErpArt } from '../registry'
import { TagebuchEinstellungen } from './TagebuchEinstellungen'
import { TagebuchErpDetail } from './TagebuchErpDetail'
import { TagebuchErpVorzeige } from './TagebuchErpVorzeige'

/** AP-48 D — der Bautagesbericht meldet sich im ERP an: Vorzeige, Detailteil, Einstellungen. */
registriereErpArt({ kind: 'DIARY', Vorzeige: TagebuchErpVorzeige, Detail: TagebuchErpDetail, Einstellungen: TagebuchEinstellungen, detailTitel: 'siteDocs.diary.countersignTitle' })
